import { render, staticRenderFns } from "./select-user-is-seller.vue?vue&type=template&id=42c8d87b"
import script from "./select-user-is-seller.vue?vue&type=script&lang=js"
export * from "./select-user-is-seller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports